import { Components, Theme } from '@mui/material/styles';
import scssVariables from '@styles/variables.module.scss';

export const MuiList: Components<Theme>['MuiList'] = {
  styleOverrides: {
    root: {
      '.MuiListSubheader-root': {
        font: scssVariables.FontLabel,
        paddingInline: 0,
        color: scssVariables.ColorBlack60,
      },
    },
  },
};
